import React from "react";
import { Modal, ModalBody } from "reactstrap";

// Importar as imagens oficiais pré-desenhadas enviadas pelo usuário (com o caminho relativo correto de 4 níveis)
import primBg from "../../../../assets/images/prim.png";
import segBg from "../../../../assets/images/seg.png";
import tercBg from "../../../../assets/images/terc.png";
import generalBg from "../../../../assets/images/bgcertfi.png"; // Fundo padrão para participação

const CertificatePrintModal = ({ isOpen, toggle, athlete }) => {
    if (!athlete) return null;

    const firstName = athlete.firstName || "Competidor";
    const lastName = athlete.lastName || "";
    const fullName = `${firstName} ${lastName}`.trim();
    const verificationCode = athlete.verificationCode || `O26-${athlete.id?.substring(0, 6).toUpperCase()}`;
    const rank = athlete.relativePosition || athlete.generalPosition || 99;

    // Determinar a imagem de fundo ideal baseado na colocação
    let certificateBackground = generalBg;
    let rankLabel = "Participante";

    if (rank === 1) {
        certificateBackground = primBg;
        rankLabel = "1º Lugar";
    } else if (rank === 2) {
        certificateBackground = segBg;
        rankLabel = "2º Lugar";
    } else if (rank === 3) {
        certificateBackground = tercBg;
        rankLabel = "3º Lugar";
    }

    // Formatar a data de homologação (português brasileiro)
    const rawDate = athlete.submittedAt || athlete.result?.submittedAt || new Date().toISOString();
    let formattedDate = "01 de Junho de 2026";
    try {
        const d = new Date(rawDate);
        formattedDate = d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
    } catch (e) {
        // Fallback
    }

    const validationUrl = `https://www.gestaoneo.com/competicao/certificado/validar?code=${verificationCode}`;
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&color=2c1810&bgcolor=ffffff&data=${encodeURIComponent(validationUrl)}`;

    const handlePrint = () => {
        window.print();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered className="certificate-modal">
            <ModalBody style={{ padding: 0, overflow: 'hidden', backgroundColor: '#faf8f5', borderRadius: '12px' }}>
                
                {/* Estilos específicos para impressão A4 Retrato (Vertical) */}
                <style>
                    {`
                        @media print {
                            /* Esconde toda a interface do site e elementos do Reactstrap */
                            body * {
                                visibility: hidden !important;
                            }
                            /* Mostra apenas a área do certificado */
                            #certificate-print-area, #certificate-print-area * {
                                visibility: visible !important;
                            }
                            #certificate-print-area {
                                position: absolute !important;
                                left: 0 !important;
                                top: 0 !important;
                                width: 210mm !important;
                                height: 297mm !important;
                                margin: 0 !important;
                                padding: 0 !important;
                                box-shadow: none !important;
                                background-color: #ffffff !important;
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                                z-index: 9999999 !important;
                            }
                            @page {
                                size: A4 portrait !important;
                                margin: 0 !important;
                            }
                        }
                    `}
                </style>

                {/* Área do Certificado */}
                <div 
                    id="certificate-print-area" 
                    style={{
                        width: '100%',
                        maxWidth: '520px',
                        margin: '0 auto',
                        aspectRatio: '1 / 1.4142', // Proporção exata do A4 (Vertical)
                        backgroundImage: `url(${certificateBackground})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                        color: '#2c1810',
                        fontFamily: "'Georgia', 'Times New Roman', serif",
                        overflow: 'hidden'
                    }}
                >
                    {/* 1. Nome do Atleta - Sobreposição Absoluta Centrada */}
                    <div 
                        style={{
                            position: 'absolute',
                            top: '49%', // Altura exata para o alinhamento sobre a linha de nome pré-desenhada
                            left: '5%',
                            right: '5%',
                            textAlign: 'center',
                            zIndex: 10,
                            pointerEvents: 'none'
                        }}
                    >
                        <span 
                            style={{ 
                                fontSize: '1.9rem', 
                                fontWeight: 'bold', 
                                color: '#1a1209', // Tom escuro outonal elegante
                                fontFamily: "'Georgia', serif",
                                display: 'block',
                                letterSpacing: '0.5px'
                            }}
                        >
                            {fullName}
                        </span>
                    </div>

                    {/* 2. Data de Emissão - Sobreposição Absoluta */}
                    <div 
                        style={{
                            position: 'absolute',
                            top: '77%', // Alinhado sobre a área da data na imagem de fundo
                            left: '5%',
                            right: '5%',
                            textAlign: 'center',
                            zIndex: 10,
                            pointerEvents: 'none'
                        }}
                    >
                        <span 
                            style={{ 
                                fontSize: '0.85rem', 
                                fontWeight: '600', 
                                color: '#4a3622', 
                                fontFamily: "Arial, sans-serif",
                                letterSpacing: '1px'
                            }}
                        >
                            {formattedDate}
                        </span>
                    </div>

                    {/* 3. Bloco de Auditoria e QR Code (Oficialização) */}
                    <div 
                        style={{ 
                            position: 'absolute',
                            bottom: '8%', 
                            right: '8%', 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center',
                            zIndex: 10
                        }}
                    >
                        {/* QR Code Dinâmico apontando para a validação */}
                        <img 
                            src={qrCodeUrl} 
                            alt="QR Validação" 
                            style={{ 
                                width: '46px', 
                                height: '46px', 
                                border: '1px solid #e8d5c0', 
                                padding: '2px',
                                backgroundColor: '#ffffff',
                                borderRadius: '4px',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                marginBottom: '4px'
                            }} 
                        />
                        {/* Código de Validação */}
                        <span 
                            style={{ 
                                fontSize: '0.5rem', 
                                fontFamily: 'monospace', 
                                color: '#5c4530', 
                                fontWeight: 'bold',
                                letterSpacing: '0.5px'
                            }}
                        >
                            VALIDAÇÃO: {verificationCode}
                        </span>
                        <span style={{ fontSize: '0.45rem', color: '#8b7355', textDecoration: 'none' }}>
                            gestaoneo.com/validar
                        </span>
                    </div>

                    {/* Badge do Rank (Opcional - Exibe no topo do certificado de forma elegante) */}
                    <div style={{
                        position: 'absolute',
                        top: '4%',
                        left: '4%',
                        backgroundColor: rank === 1 ? '#d4af37' : (rank === 2 ? '#c0c0c0' : (rank === 3 ? '#cd7f32' : 'rgba(44, 24, 16, 0.7)')),
                        color: '#fff',
                        fontSize: '0.62rem',
                        fontWeight: 'bold',
                        padding: '4px 10px',
                        borderRadius: '20px',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        fontFamily: 'sans-serif'
                    }}>
                        {rankLabel}
                    </div>
                </div>

                {/* Barra de Ações Inferior (Visível apenas na tela) */}
                <div style={{ 
                    padding: '16px 20px', 
                    borderTop: '1px solid #eee', 
                    display: 'flex', 
                    justifyContent: 'flex-end', 
                    gap: '10px',
                    backgroundColor: '#ffffff' 
                }}>
                    <button 
                        onClick={toggle} 
                        className="btn btn-light" 
                        style={{ borderRadius: '6px', fontWeight: '600' }}
                    >
                        Fechar
                    </button>
                    <button 
                        onClick={handlePrint} 
                        className="btn btn-primary" 
                        style={{ 
                            borderRadius: '6px', 
                            fontWeight: '600',
                            backgroundColor: '#2d6a4f',
                            borderColor: '#2d6a4f'
                        }}
                    >
                        <i className="mdi mdi-printer mr-1" /> Imprimir / Salvar PDF
                    </button>
                </div>

            </ModalBody>
        </Modal>
    );
};

export default CertificatePrintModal;
